import React from 'react';
import NewManageDeviceContainer from '@src/containers/NewManageDevice';

const ManageDevice = () => <NewManageDeviceContainer />;

export default ManageDevice;
